var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.05Q27.35 6.05 29.65 8.35Q31.95 10.65 31.95 14.05V18.3H34.8Q36.2 18.3 37.175 19.25Q38.15 20.2 38.15 21.65V39.15Q38.15 40.55 37.175 41.525Q36.2 42.5 34.8 42.5H13.2Q11.8 42.5 10.825 41.525Q9.85 40.55 9.85 39.15V21.65Q9.85 20.2 10.825 19.25Q11.8 18.3 13.2 18.3H16.05V14.05Q16.05 10.65 18.35 8.35Q20.65 6.05 24 6.05ZM24 7.8Q21.4 7.8 19.6 9.625Q17.8 11.45 17.8 14.05V18.3H30.2V14.05Q30.2 11.45 28.4 9.625Q26.6 7.8 24 7.8ZM13.2 40.75H34.8Q35.5 40.75 35.95 40.3Q36.4 39.85 36.4 39.15V21.65Q36.4 20.95 35.95 20.5Q35.5 20.05 34.8 20.05H13.2Q12.5 20.05 12.05 20.5Q11.6 20.95 11.6 21.65V39.15Q11.6 39.85 12.05 40.3Q12.5 40.75 13.2 40.75ZM24 27.45Q22.75 27.45 21.875 28.35Q21 29.25 21 30.5Q21 31.7 21.875 32.575Q22.75 33.45 24 33.45Q25.25 33.45 26.125 32.575Q27 31.7 27 30.45Q27 29.25 26.125 28.35Q25.25 27.45 24 27.45ZM11.6 20.05Q11.6 20.05 11.6 20.5Q11.6 20.95 11.6 21.65V39.15Q11.6 39.85 11.6 40.3Q11.6 40.75 11.6 40.75Q11.6 40.75 11.6 40.3Q11.6 39.85 11.6 39.15V21.65Q11.6 20.95 11.6 20.5Q11.6 20.05 11.6 20.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.8acda2374855b2712def7330fcceee25.svg";
export { ForwardRef as ReactComponent };